/**
 * Refactoring opportunity:
 * @see getDaysUntilExpiration
 * @see getHoursUntilExpiration
 */
export const getRemainingTime = (
  deadline: string,
  specificity: "days" | "hours" | "minutes" | "seconds"
) => {
  const currentDate = new Date();
  const deadlineDate = new Date(deadline);
  // get total seconds between the times
  const difference = deadlineDate.valueOf() - currentDate.valueOf();
  if (difference <= 0) {
    return 0;
  }
  let delta = difference / 1000;
  // calculate (and subtract) whole days
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  // calculate (and subtract) whole hours
  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;
  // calculate (and subtract) whole minutes
  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;
  // finally seconds
  const seconds = delta % 60;
  switch (specificity) {
    case "days":
      return days;
    case "hours":
      return hours;
    case "minutes":
      return minutes;
    case "seconds":
      return seconds;
  }
};

export function hasPassedDate(startDate: Date, days: number) {
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + days);
  return new Date() > endDate;
}

export function parseDate(dateString: string): Date | null {
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? null : date;
}

export function getToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}
